/* eslint-disable no-unused-vars */
import { ModelApiService } from './BaseApiService'
import { TimeEntryStatusResponse } from '@/models/booking/timeEntries/responses/timeEntryStatusResponse'
import { TimeEntryBookingsResponse } from '@/models/booking/timeEntries/responses/timeEntryBookingsResponse'
import { TimeEntryClockInRequest } from '@/models/booking/timeEntries/requests/timeEntryClockInRequest'
import { TimeEntryMealBreakStartRequest } from '@/models/booking/timeEntries/requests/timeEntryMealBreakStartRequest'
import { TimeEntryMealBreakEndRequest } from '@/models/booking/timeEntries/requests/timeEntryMealBreakEndRequest'
import { MealBreakStatusResponse } from '@/models/booking/timeEntries/responses/mealBreakStatusResponse'

export default class TimeEntriesApiService extends ModelApiService {
  constructor() {
    super('time-entries')
  }

  /**
   * Returns the current clock in status for the candidate
   *
   * @returns {Promise<ResultDTO<TimeEntryStatusResponse>}
   */
  getStatus() {
    return this.get('status')
  }

  /**
   * Returns a list of shifts the candidate is placed in for the current day.
   * Will only return shifts the candidate can clock in to.
   *
   * @returns {Promise<ResultDTO<TimeEntryBookingsResponse>>}
   */
  getTodaysShifts() {
    return this.get('bookings')
  }

  /**
   * Clocks a candidate in to the specified booking
   *
   * @param {TimeEntryClockInRequest} payload
   * @returns {Promise<ResultDTO<TimeEntryStatusResponse>>}
   */
  clockIn(payload) {
    return this.post('clock-in', payload)
  }

  /**
   * Clocks a candidate out of a specified booking
   *
   * @param {TimeEntryClockInRequest} payload
   * @returns {Promise<ResultDTO<TimeEntryStatusResponse>>}
   */
  clockOut(payload) {
    return this.post('clock-out', payload)
  }

  /**
   * Starts a meal break on a specified booking
   *
   * @param {TimeEntryMealBreakStartRequest} payload
   * @returns {Promise<ResultDTO<TimeEntryStatusResponse>>}
   */
  startMealBreak(payload) {
    return this.post('meal-break-start', payload)
  }

  /**
   * Ends a meal break on a specified booking
   *
   * @param {TimeEntryMealBreakEndRequest} payload
   * @returns {Promise<ResultDTO<TimeEntryStatusResponse>>}
   */
  endMealBreak(payload) {
    return this.post('meal-break-end', payload)
  }

  /**
   * Retrieve the status of the candidate's current meal break
   *
   * @returns {Promise<ResultDTO<MealBreakStatusResponse>>}
   */
  getMealBreakStatus() {
    return this.get('meal-break/status')
  }
}
